import React from 'react';
import PolicyLayout from '../../components/seo/PolicyLayout';

const TermsConditions = () => {
  return (
    <PolicyLayout 
      title="Termini e Condizioni" 
      subtitle="Regolamento di utilizzo del sito e dei servizi Molinaro Immobiliare"
      lastUpdated="10 Giugno 2025"
    >
      <h3>1. Introduzione</h3>
      <p>
        I presenti Termini e Condizioni regolano l'utilizzo del sito web molinaroimmobiliare.it (di seguito "Sito") e i servizi offerti da 
        Molinaro Immobiliare con sede legale in Via Pisana 327, 50018 Scandicci (FI), P.IVA 06705840483 (di seguito "Molinaro Immobiliare", "noi" o "nostro").
      </p>
      <p>
        L'accesso e l'utilizzo del Sito sono subordinati all'accettazione e all'osservanza di tutti i termini e condizioni qui di seguito stabiliti. 
        Si prega di leggere attentamente questo documento prima di accedere o utilizzare il nostro Sito.
      </p>
      
      <h3>2. Accettazione dei termini</h3>
      <p>
        Utilizzando il nostro Sito, l'utente dichiara di aver letto, compreso e accettato i presenti Termini e Condizioni e si impegna a rispettarli. 
        Se non si accettano questi termini, si prega di non utilizzare il Sito.
      </p>
      <p>
        Ci riserviamo il diritto di modificare questi Termini e Condizioni in qualsiasi momento. Le modifiche entrano in vigore immediatamente dopo 
        la pubblicazione sul Sito. L'uso continuato del Sito dopo tali modifiche costituisce accettazione dei nuovi Termini e Condizioni.
      </p>
      
      <h3>3. Servizi offerti</h3>
      <p>
        Molinaro Immobiliare offre attraverso il Sito i seguenti servizi:
      </p>
      <ul>
        <li>Informazioni sugli immobili in vendita e in affitto</li>
        <li>Richiesta di informazioni sugli immobili</li>
        <li>Servizi di valutazione immobiliare</li>
        <li>Consulenza immobiliare</li>
        <li>Newsletter e aggiornamenti sul mercato immobiliare</li>
      </ul>
      <p>
        Le informazioni fornite sul Sito hanno scopo puramente informativo e non costituiscono un'offerta vincolante. 
        Nonostante il nostro impegno per mantenere accurate e aggiornate tutte le informazioni, non possiamo garantire la totale assenza di errori. 
        Pertanto, i dettagli definitivi relativi agli immobili (prezzo, disponibilità, caratteristiche) sono soggetti a conferma da parte di Molinaro Immobiliare.
      </p>
      
      <h3>4. Proprietà intellettuale</h3>
      <p>
        Tutti i contenuti presenti sul Sito, quali testi, immagini, fotografie, grafica, loghi, video e in generale ogni elemento pubblicato 
        sono di proprietà di Molinaro Immobiliare o di terzi che ne hanno concesso l'utilizzo e sono protetti dalle leggi sul diritto d'autore e sulla proprietà intellettuale.
      </p>
      <p>
        È vietata la riproduzione, la modifica, la distribuzione, la trasmissione, la ripubblicazione, la visualizzazione o l'esecuzione 
        di qualsiasi contenuto del Sito senza il nostro esplicito consenso scritto.
      </p>
      
      <h3>5. Utilizzo del sito</h3>
      <p>
        L'utente si impegna a utilizzare il Sito e i suoi servizi in modo conforme alla legge, ai presenti Termini e Condizioni, 
        nonché alle norme di buona condotta e di rispetto verso altri utenti e terzi.
      </p>
      <p>
        In particolare, l'utente si impegna a non:
      </p>
      <ul>
        <li>Utilizzare il Sito in modo da causare danni, sovraccarichi, interruzioni o deterioramenti del Sito stesso</li>
        <li>Tentare di accedere a account o sistemi informatici senza autorizzazione</li>
        <li>Diffondere virus, malware o altro codice dannoso</li>
        <li>Raccogliere informazioni sugli altri utenti senza il loro consenso</li>
        <li>Utilizzare il Sito per finalità illegali, fraudolente o lesive dei diritti di terzi</li>
      </ul>
      
      <h3>6. Contenuti degli annunci immobiliari</h3>
      <p>
        Le descrizioni, le immagini e tutte le informazioni relative agli immobili pubblicati sul Sito sono inserite con la 
        massima attenzione e accuratezza possibile.
      </p>
      <p>
        Tuttavia, Molinaro Immobiliare non può garantire l'assoluta precisione di tali informazioni né l'assenza di errori 
        o imprecisioni. Pertanto, le descrizioni, le misure, le planimetrie, le fotografie e ogni altra informazione relativa 
        agli immobili hanno carattere indicativo e non costituiscono elemento contrattuale.
      </p>
      <p>
        Prima di qualsiasi decisione di acquisto, affitto o altra transazione immobiliare, consigliamo agli utenti di verificare 
        personalmente le informazioni durante un sopralluogo dell'immobile.
      </p>
      
      <h3>7. Privacy e protezione dei dati personali</h3>
      <p>
        La raccolta e il trattamento dei dati personali degli utenti avvengono nel rispetto del Regolamento UE 2016/679 (GDPR) 
        e del D.Lgs. 196/2003 (Codice Privacy) come modificato dal D.Lgs. 101/2018.
      </p>
      <p>
        Per informazioni dettagliate su come trattiamo i tuoi dati personali, ti invitiamo a consultare la nostra 
        <Link to="/privacy-policy">Privacy Policy</Link>.
      </p>
      
      <h3>8. Cookie</h3>
      <p>
        Il nostro Sito utilizza cookie e tecnologie simili per migliorare la tua esperienza di navigazione, analizzare 
        l'utilizzo del Sito e personalizzare i contenuti.
      </p>
      <p>
        Per maggiori informazioni su come utilizziamo i cookie e su come gestirli, consulta la nostra 
        <Link to="/cookie-policy">Cookie Policy</Link>.
      </p>
      
      <h3>9. Collegamenti a siti esterni</h3>
      <p>
        Il Sito può contenere collegamenti a siti web esterni non gestiti da Molinaro Immobiliare. 
        Non abbiamo alcun controllo sui contenuti, le politiche sulla privacy o le pratiche di tali siti e non assumiamo 
        alcuna responsabilità in relazione ad essi.
      </p>
      <p>
        L'inclusione di qualsiasi collegamento non implica necessariamente una raccomandazione o l'approvazione dei contenuti 
        dei siti collegati. Ti invitiamo a leggere attentamente i termini e le condizioni e l'informativa sulla privacy di 
        qualsiasi sito web esterno che visiti tramite i link presenti sul nostro Sito.
      </p>
      
      <h3>10. Limitazione di responsabilità</h3>
      <p>
        Molinaro Immobiliare non è responsabile per danni diretti, indiretti, incidentali, consequenziali o speciali 
        derivanti dall'accesso o dall'utilizzo, o dall'impossibilità di accedere o utilizzare il Sito e i suoi contenuti.
      </p>
      <p>
        Non garantiamo che il Sito sia sempre disponibile, privo di errori o virus. L'utente è responsabile dell'implementazione 
        di procedure e controlli antivirus adeguati.
      </p>
      <p>
        Inoltre, non siamo responsabili per eventuali perdite di opportunità, guadagni o altre perdite economiche 
        derivanti da decisioni prese in base alle informazioni presenti sul Sito.
      </p>
      
      <h3>11. Legge applicabile e foro competente</h3>
      <p>
        I presenti Termini e Condizioni sono regolati dalla legge italiana. Per qualsiasi controversia relativa 
        all'interpretazione, all'esecuzione o alla risoluzione dei presenti Termini e Condizioni sarà competente 
        in via esclusiva il Foro di Firenze, salvo quanto previsto dalla normativa a tutela dei consumatori.
      </p>
      
      <h3>12. Contatti</h3>
      <p>
        Per qualsiasi domanda, segnalazione o richiesta relativa ai presenti Termini e Condizioni, potete contattarci ai seguenti recapiti:
      </p>
      <p>
        <strong>Molinaro Immobiliare</strong><br />
        Via Pisana 327<br />
        50018 Scandicci (FI)<br />
        Email: info@molinaroimmobiliare.it<br />
        Telefono: +39 327 8855115
      </p>
    </PolicyLayout>
  );
};

export default TermsConditions;